<template>
	<div class="app layout layout--app color color--fontBlack background background--middleGrey minHeight minHeight--100">
		
		<CvSidebar></CvSidebar>
		
		<main class="app__body">			
			<transition 
				name="fade" 
				mode="out-in" 
				:duration="{ leave: 0, enter: 0 }"
				appear>
				<router-view class="app__bodyInner" />
			</transition>
			
			<div class="app__loadingSpinner"></div>
		</main>
		
		<MhModal class="modalWindow modalWindow--datasets" :show="showTableModal" @close="showTableModal = false">
			<template slot="header">
				<div class="vhSpace--medium flex flex--spaceBetween font font--sizeBig">
					<span>{{currentFilename}}</span>
					<a class="modalWindow__closeBtn" @click="showTableModal = false">×</a>
				</div>
			</template>
			<template slot="body">
				<div class="vhSpace--medium">
					
					<CvTable v-if="showTableModal"></CvTable>

				</div>
			</template>
			<!--
			<template slot="footer">
				<div class="vhSpace--medium">
					<mark>Paginierung fehlt</mark>
				</div>
			</template>
			-->
		</MhModal>
		
		<MhModal class="modalWindow modalWindow--help" :show="showHelpModal" @close="showHelpModal = false">
			<template slot="header">
				<div class="vhSpace--medium flex flex--spaceBetween font font--sizeBig">
					<span>Anleitung</span>
					<a class="modalWindow__closeBtn" @click="showHelpModal = false">×</a>
				</div>
			</template>
			<template slot="body">
				<div class="vhSpace--medium">
					
					<ul>
					<li> Die zulässigen Feldinhalte der jeweiligen CSV-Dateien finden Sie in unseren <a href="https://www.denkmalpflege-bw.de/geschichte-auftrag-struktur/archaeologische-denkmalpflege/firmenarchaeologie/" target="_blank">Vorlagen</a>. Die detaillierte Beschreibung der Feldinhalte entnehmen Sie der aktuellen Grabungsrichtlinie.</li>
					<li> 1. Wählen Sie Ihre lokale CSV-Datei über den Button „CSV hochladen“ aus. </li>
					<li> 2. Wählen Sie über „Schema wählen“ das passende Schema Ihrer Datei</li>
					<li> 3. Klicken Sie validieren.</li>
					<li> Die Kopfzeile Ihrer CSV-Datei muss vollständig identisch sein mit der Kopfzeile der jeweiligen Vorlage. </li>
					<li> Bitte achten Sie darauf, dass die Kommentarzeile unterhalb der ersten Kopfzeile nicht in der CSV-Datei enthalten ist (sie dient nur der Erläuterung). </li>
					<li> Ist Ihre CSV-Datei interpretierbar, wird Sie als Formularfelder (eine CSV Zeile = ein Formularreiter) im Browser angezeigt. </li>
					<li> Alle fehlerhaften Eingaben werden rot markiert. </li>
					<li> Möchten Sie Zeilen vom späteren Export entfernen können Sie über das (x) des Reiters den Datensat löschen </li>
					<li> Mit der Checkbox „Nur Probleme anzeigen“ reduziert sich die Anzeige auf auf Formulare, die noch Fehler enthalten </li>
					<li> Feldinhalte können im Browser korrigiert werden. Sind die Angaben fehlerfrei, blenden sich die Buttons zum Export der CSV ein </li>
					<li> <strong>Wichtig: Fehlerhafte CSV-Dateien werden vom LAD nicht angenommen und zur Korrektur zurückverwiesen.</strong></li>
					</ul>

				</div>
			</template>
			<template slot="footer"></template>
		</MhModal>
		
		<MhModal class="modalWindow modalWindow--imprint" :show="showImprintModal" @close="showImprintModal = false">
			<template slot="header">
				<div class="vhSpace--medium flex flex--spaceBetween font font--sizeBig">
					<span>Impressum</span>
					<a class="modalWindow__closeBtn" @click="showImprintModal = false">×</a>
				</div>
			</template>
			<template slot="body">
				<div class="vhSpace--medium">
					
					<strong>Anbieter</strong><br />
					<br />
					Landesamt für Denkmalpflege<br />
					Berliner Straße 12<br />
					73728 Esslingen (Neckar)<br />
					Mail: <a href="mailto:firmengrabungen@rps.bwl.de">firmengrabungen@rps.bwl.de</a> <br />
					<br />
					Beachten Sie bitte, dass Ihre Mitteilung an uns über eine E-Mail nicht verschlüsselt wird. Ohne Verschlüsselung ist die Kenntnisnahme durch Dritte nicht ausgeschlossen. Soweit wir Ihrer Mitteilung entnehmen können, dass Sie eine Antwort wünschen, gehen wir davon aus, dass Sie mit einer Beantwortung durch eine unverschlüsselte E-Mail einverstanden sind, wenn unsere Antwort auch nach ihrem Inhalt keiner Verschlüsselung bedarf.<br />
					<br />
					
					<strong>Hinweise zur Nutzung:</strong><br />
					<br />
					<ol>
						<li>
							Das Nutzungsrecht wird Ihnen unentgeltlich eingeräumt.
						</li>
						<li>
							Das Landesamt für Denkmalpflege Baden-Württemberg im Regierungspräsidium Stuttgart übernimmt
							keine Haftung für Hard- oder Softwareschäden, die durch die Anwendung dieser Anwendung verursacht werden.
						</li>
						<li>Es wird keinerlei Support für die Software gewährleistet. Das LAD und CSGIS haften nicht für Fahrlässigkeit.
							Eine Haftung für mittelbare Schäden oder die Wiederbeschaffung von Daten wird ausgeschlossen.
						</li>
					</ol>
					<br />
					
					<strong>Projektteam</strong><br />
					<br />
					Marco Schrickel<br />
					Mario Helbing<br />
					Toni Schönbuchner<br />
					<br />
					<strong>Projektumsetzung</strong><br />
					<br />
					CSGIS GbR<br />
					Am Eichbüchl 7<br />
					D - 82223 Eichenau<br />
					<a href="https://www.csgis.de/">www.csgis.de</a><br />

				</div>
			</template>
			<template slot="footer"></template>
		</MhModal>
		
		<MhDevInfos :showOnHosts="['localhost']"></MhDevInfos>
		
		<!--
		<MhDelegateLinks></MhDelegateLinks>
		<MhDebugGrid></MhDebugGrid>
		-->
	</div>
</template>

<script>
	// @ is an alias to /src 
	
	//import BaseSelect from '@/components/MhForm/BaseSelect.vue'
	import MhDevInfos from '@/components/MhDevInfos/MhDevInfos.vue'
	import MhDelegateLinks from '@/components/MhDelegateLinks/MhDelegateLinks.vue'
	import MhModal from '@/components/MhModal/MhModal.vue'
	
	import CvSidebar from '@/components/CvSidebar.vue'
	import CvBody from '@/components/CvBody.vue'
	import CvTable from '@/components/CvTable.vue'
	
	// um das webworker feature zum laufen zu bekommen:
	// muss diese var gesetzt sein UND papaparse.js
	// muss sich im public-ordner befinden damit es per 
	// url aufgerufen werden kann
	// taken and modified from https://github.com/mholt/PapaParse/issues/655
	/* eslint-disable */ 
	//import papa from '@/assets/papaparse.js'
	//import papa from './papaparse.js'
	//papa.SCRIPT_PATH = "./papaparse.js"; 
	/* eslint-enable */ 
	
	import { rules } from '@/validatorConfig/scripts/rules.js'
	import generateAndDownloadPDF from '@/validatorConfig/scripts/printReport'
	import allSchemes from '@/validatorConfig/scripts/schemeRegister-all'
	
	export default {
		name: 'App',
		components: {
			MhDevInfos,
			MhDelegateLinks,
			MhModal,
			CvSidebar,
			CvBody,
			CvTable,
		},
		data() {
			return {
				choosenCsvFile   : undefined,
				//selectedScheme : '', //undefined,
				//selectedScheme : 'Skelettbeschreibung v3', //undefined,
				//selectedScheme : 'Probenliste v3', //undefined,
				//selectedScheme : 'Planumsbeschreibung v3', //undefined,
				//selectedScheme : 'Fundliste v4', //undefined,
				//selectedScheme   : 'Befundbeschreibung v4', //undefined,
				selectedScheme   : '',
				isParsing        : false,
				schemes          : allSchemes,
				showErrorsOnly   : false,
				showTableModal   : false,
				showHelpModal    : false,
				showImprintModal : false,
				currentFilename  : '',
				currentCharset   : 'UTF-8',
				currentDatasetIndex : 0,
				gui              : {
					view         : 'CvIntro'
				},
				inputData        : {	// hier landen die geparsten daten aus der csv vor der validierung
					filename    : '',
					headerCols  : [],
					bodyRows    : [],
				},
				outputData       : { // hier landen die validierten daten die dann angezeigt werden
					filename    : '',
					isValid     : undefined,
					countErrors : 0,
					countCells  : 0,
					headerCols  : [],
					bodyRows    : [],
				},
				
				dev : {
					testCsvFiles : [
						'/testFiles/v3/befundbeschreibung.csv',
						'/testFiles/v3/2028_022_Fotoliste.csv',
						'/testFiles/v3/2019_022_Fundliste.csv',
						'/testFiles/v3/2019_022_Fundliste-valid.csv',
						'/testFiles/v3/2018_022_Planumsbeschreibung.csv',
						'/testFiles/v3/2018_022_Probenliste.csv',
						'/testFiles/v3/Profilliste.csv',
						'/testFiles/v3/Profilbeschreibung.csv',
						'/testFiles/v3/Skelettbeschreibung.csv',
												
						'/testFiles/v3/2018_022_Probenliste_mit_falscher_zusaetzlicher_Spalte.csv',
						'/testFiles/v3/2018_022_Probenliste_mit_falschen_cells.csv',
						'/testFiles/v3/2019_022_Fundliste_2.csv',
						'/testFiles/v3/2019_022_Fundliste_mit_falschen_cells.csv',
					],
				}
			}
		},
		watch: {
			'currentFilename': { // reset tabs if doc changes
				handler: function( to, from ) {
					this.showErrorsOnly = false
				},
				deep: true,
			},
			'selectedScheme': { // reset tabs if doc changes
				handler: function( to, from ) {
					if( this.gui.view == 'CvSheet' ) this.doCreateOutputData()
				},
				deep: true,
			},
			'isReadyToDownload': { // make sure that all tabs are visible before download
				handler: function( to, from ) {
					if( to ) this.showErrorsOnly = false
				},
				deep: true,
			},
		},
		computed: {
			isReadyToValidate(){
				return ( 
					this.choosenCsvFile && 
					this.currentFilename && 
					this.selectedScheme ) ? true : false
			},
			isReadyToDownload(){
				return ( this.outputData.countErrors == 0 && this.gui.view == 'CvSheet' && this.outputData.bodyRows.length ) ? true : false
			},
			currentHost(){
				return location.protocol+'//'+location.hostname+(location.port ? ':'+location.port: '')
			},
			rules(){
				return rules
			},
			isDevEnv(){
				const hostname = window.location.hostname
				return window.location.hostname.includes('localhost')
			},
		},
		methods: {
			reset(){
				this.showErrorsOnly = false
				this.selectedScheme = ''
				this.gui.view = 'CvIntro'
				this.inputData = {
					filename    : [],
					headerCols  : [],
					bodyRows    : [],
				}
				this.outputData = { 
					isValid     : undefined,
					countErrors : 0,
					countCells  : 0,
					headerCols  : [],
					bodyRows    : [],
				}
			},
			removeCsvFile(){
				this.choosenCsvFile = undefined
				this.currentFilename = ''
				
				const inputElm = document.querySelector('#filePicker')
				
				if( inputElm ){ 
					inputElm.value = "";
				}
			},
			onSelectFile( event ){
				const files = event.target.files
				const file = files.item(0)
				
				console.log(event.target.files)
				console.log( file )
				
				this.choosenCsvFile = file
				this.currentFilename = file.name
			},	
			cleanString( keyStr ){ // cleans column names
				let newStr = keyStr
				
				newStr = newStr.replace(/^[\s]+/g, '') // RemoveFirstBlank
				newStr = newStr.replace(/[^\x00-\x7F]/g, '') // RemoveNonAscii
				newStr = newStr.replace(/[\t]+/g, '') // RemoveTab
				
				return newStr
			},
			getDateStr(){
			    var today = new Date();
			    var y = today.getFullYear();
			    var m = today.getMonth() + 1; // JavaScript months are 0-based.
			    var d = today.getDate();
			    return "-" + d + "." + m + "." + y;
			},
			
			doParseCsv( url = null ){ // parse the given csv to json
				const csvFilename = url ? url.replace(/^.*[\\\/]/, '') : this.choosenCsvFile.name
				const parseTarget = url ? url : this.choosenCsvFile
				
				this.isParsing       = true
				this.currentFilename = csvFilename
				
				Papa.parse( parseTarget, {				
					delimiter      : ";", // auto-detect <<< habe ich so von Tonis Code übernommen
					newline        : "", // auto-detect
					quoteChar      : '"',
					header         : true,
					dynamicTyping  : false,
					preview        : 0,
					encoding       : "UTF-8",
					worker         : true,
					comments       : false,
					step           : undefined,
					download       : true,
					skipEmptyLines : true,
					chunk          : undefined,
					fastMode       : undefined,
					withCredentials: undefined,					
					error: function error(_error) {
						// hides parsing progress indicator
						setTimeout(()=>{ this.isParsing = false }, 500)
						
						return alert(_error);
					},
					complete: ( response )=>{
						setTimeout(()=>{
							this.inputData.filename = csvFilename
							this.doCreateInputData( response ) // sets isParsing to false
						}, 50 )
					},
				})
				
			},
			doCreateInputData( response, doLog = false ){
				if( doLog ) console.group('doCreateInputData()')
				if( doLog ) console.log('response:', response)
				
				let headerCols = response.meta.fields
				let bodyRows  = response.data

				// reset vars
				this.inputData.headerCols = []
				this.inputData.bodyRows = []
				
				// add the header row with col names
				this.inputData.headerCols = headerCols.map(n => this.cleanString(n) )

				// add the body rows 
				this._.forEach( bodyRows, (value, i)=>{
					//console.log(i)
					
					const newRow = {
						cells   : [],
					}
					for( const [key, value] of Object.entries(value) ){  								
						//console.log(`${key}: ${value}`)
						
						const newCol = {
							key     : this.cleanString( key ),
							value   : value,
							isValid : undefined,
						}
						
						newRow.cells.push( newCol )
					}
					
					this.inputData.bodyRows.push( newRow )
					
					//console.log('---')
				})
				
				// change the app view 
				//this.$router.push({ name: 'CvViewValidate' })
				
				if( doLog ) console.groupEnd()
				
				this.doCreateOutputData()
				
				// hides parsing progress indicator
				setTimeout(()=>{ this.isParsing = false }, 500)
			},
			doCreateOutputData( doLog = false ){
				const validatorScheme = this._.get( allSchemes, this.selectedScheme )
			
				if( doLog ){
					console.group('doCreateOutputData()')
					console.log('   selectedScheme:', this.selectedScheme)
					console.log('  validatorScheme:', validatorScheme)
					console.log('        inputData:', this.inputData)
					console.log('---------------')
				}
				
				// new filename
				const inputFilename = this.inputData.filename
				const newBasename   = inputFilename.split('.').slice(0, -1).join('.')
				//const appendix      = "-validiert"+this.getDateStr()
				//const newFilename   = newBasename + appendix				
				const newFilename   = newBasename + '.csv'
				
				/*
				console.log('inputFilename:', inputFilename)
				console.log('newBasename:', newBasename)
				console.log('appendix:', appendix)
				console.log('newFilename:', newFilename)
				*/
				
				// reset before
				this.outputData.isValid     = true
				this.outputData.countErrors = 0
				this.outputData.countCells  = 0
				this.outputData.headerCols  = []
				this.outputData.bodyRows    = []
				this.outputData.filename    = ''
				this.outputData.filename    = newFilename
				
				// walk the inputData.headerCols to build outputData.headerCols
				// es werden alle spalten entfernt, die nicht ins schema passen
				/*
				this._.forEach( this.inputData.headerCols, (col, colIndex)=>{
					const hasRule = this._.has( validatorScheme, col ) ? true : false
					
					if( hasRule ){
						this.outputData.headerCols.push( col )						
					}
				})
				*/
				
				// build outputData.headerCols anhand des gewählten schemes
				this._.forEach( validatorScheme, (v, k)=>{
					this.outputData.headerCols.push( k )
				})
				
				// walk the rows to build outputData.bodyRows
				// es werden nur spalten berücksichtig, die teile des schemas sind.
				// alle zellen werden gegen das schema validiert
				// eine fehlerhafte zelle führt zu einer fehlerhaften zeile und data
				this._.forEach( this.inputData.bodyRows, (row, rowIndex)=>{
					if( doLog ) console.group('rowIndex:', rowIndex)
					
					const newRow = {
						isValid : true,
						cells   : [],
					}
					
					// walk the cells 
					this._.forEach( this.outputData.headerCols, (k)=>{
						const cell     = this._.find( row.cells, (c) =>{ return c.key == k })
						const value    = (cell && this._.isString( cell.value )) ? this._.trim( cell.value, '"') : ''
						const hasRule  = true
						const rule     = hasRule ? this._.get( validatorScheme, k ).testFn : false
						const ruleName = hasRule ? this._.get( validatorScheme, k ).testFor : false
						const isValid  = rule( value ) === true ? true : false
						
						/*
						console.log('k:', k)
						console.log('cell:', cell)
						console.log('value:', value)
						console.log('hasRule:', hasRule)
						console.log('rule:', hasRule)
						console.log('ruleName:', hasRule)
						console.log('isValid:', hasRule)
						*/
						
						const newCell = {
							key     : k,
							value   : this._.trim(value),
							rule    : ruleName,
							ruleFn  : rule,
							isValid : isValid,
						}
						
						// push the cell to row
						newRow.cells.push( newCell )
						
						// increase cell count
						this.outputData.countCells++
						
						// if cell is not valid > unvalid row
						if( !isValid ) newRow.isValid = false
						
						// if cell is not valid > unvalid the whole data
						if( !isValid ) this.outputData.isValid = false
						
						// if cell is not valid > count error
						if( !isValid ) this.outputData.countErrors++
					})	
						
					// walk the cells
					/*
					this._.forEach( row.cells, (cell, cellIndex)=>{
						const key      = cell.key
						const value    = this._.isString( cell.value ) ? this._.trim( cell.value, '"') : value
						const hasRule  = this._.has( validatorScheme, key ) ? true : false
						const rule     = hasRule ? this._.get( validatorScheme, key ).testFn : false
						const ruleName = hasRule ? this._.get( validatorScheme, key ).testFor : false
						
						//console.log('validatorScheme:', validatorScheme)
						//console.log('key:', key)
						//console.log('ruleName:', ruleName)
						
						// es werden nur cells validiert, die auch eine rule haben
						// so werden ungültige cells ausgeschlossen
						// eine ungültige cell setzt die jeweilige row als invalid
						if( hasRule ){						
							const isValid = rule(value) === true ? true : false
							
							const newCell = {
								key     : key,
								value   : this._.trim(value),
								rule    : ruleName,
								isValid : isValid,
								//isValid : isValid,
							}
							
							// push the cell to row
							newRow.cells.push( newCell )
							
							// increase cell count
							this.outputData.countCells++
							
							// if cell is not valid > unvalid row
							if( !isValid ) newRow.isValid = false
							
							// if cell is not valid > unvalid the whole data
							if( !isValid ) this.outputData.isValid = false
							
							// if cell is not valid > count error
							if( !isValid ) this.outputData.countErrors++
						}
					})
					*/
					
					// push the validated row to data
					//if( newRow.cells.length ) 
					this.outputData.bodyRows.push( newRow )
					
					if( doLog ) console.groupEnd()
				})
				
				// walk the rows to remove empty ones
				//this._.forEach( this.outputData.bodyRows, () )
				
				this.gui.view = 'CvSheet'
				
				if( doLog ) console.groupEnd()
			},
			
			// wenn ein datensatz geändert wurde:
			// 1. ändere die daten in outputData
			// 2. revalidiere 
			doChangeInputDatasetAndRevalidate( newValue, bodyRowIndex, cellIndex, dataset, doLog = false ){
				const oldValue    = this.outputData.bodyRows[bodyRowIndex].cells[cellIndex].value
				const wasValid    = dataset.ruleFn( oldValue )
				const isValid     = dataset.ruleFn( newValue )
				const countErrors = this.outputData.countErrors
				
				if( doLog ){
					console.group('doChangeInputDatasetAndRevalidate()')
					console.log('bodyRowIndex:', bodyRowIndex)
					console.log('   cellIndex:', cellIndex)
					console.log('     dataset:', dataset)
					console.log('         key:', dataset.key)
					console.log('------------')					
					console.log('    oldValue:', oldValue)
					console.log('    wasValid:', wasValid)
					console.log(' countErrors:', countErrors)
					console.log('------------')					
					console.log('    newValue:', newValue)
					console.log('     isValid:', isValid)
				}
				
				this.outputData.bodyRows[bodyRowIndex].cells[cellIndex].value   = newValue
				this.outputData.bodyRows[bodyRowIndex].cells[cellIndex].isValid = isValid
				
				// was valid before but now invalid: increase countErrors
				if( wasValid && !isValid ){
					++this.outputData.countErrors
				}
				// was invalid before but now valid: decrease countErrors
				if( !wasValid && isValid ){
					--this.outputData.countErrors
				}				
				
				// set wrapping row valid state 
				let rowIsValid = true
				this.outputData.bodyRows[bodyRowIndex].cells.forEach((c)=>{					
					if( !c.isValid ) rowIsValid = false
				})
				this.outputData.bodyRows[bodyRowIndex].isValid = rowIsValid
				
				// find cell in inputData and set the new value				
				/*
				this._.forEach( this.inputData.bodyRows[bodyRowIndex].cells, (cell)=>{
					if( cell.key == dataset.key ) cell.value = newValue
				})
				*/
				
				if( doLog ) console.groupEnd()
				
				//this.doCreateOutputData()
			},	
			doDownloadCsv( doLog = false ){ // handles the csv download
				if( doLog ){
					console.group('doDownloadCsv()')
				}
				
				const newBasename = this.outputData.filename.split('.').slice(0, -1).join('.')
				const appendix    = "-validiert"+this.getDateStr()
				const filename    = newBasename + appendix + '.csv'
				const header      = this.outputData.headerCols
				const body        = []
				
				// generate body array for papa 	
				this._.forEach(this.outputData.bodyRows, (row)=>{
					const newRow = this._.map( row.cells, (cell)=>{ return cell.value })
					body.push(newRow)
				});
				
				// generate csvStr for download	
				var csvStr = Papa.unparse({
					fields : header,
					data   : body,
				}, {
					quotes: true, //or array of booleans
					quoteChar: '"',
					escapeChar: '"',
					delimiter: ";",
					header: true,
					newline: "\r\n",
					skipEmptyLines: false, //other option is 'greedy', meaning skip delimiters, quotes, and whitespace.
					columns: null //or array of strings
				})
				
				if( doLog ){
					console.log('  header:', header)
					console.log('    body:', body)
					console.log('  csvStr:', csvStr)
					console.log('filename:', filename)
					console.groupEnd()
				}
				
				// start the download via fake link click
				const downloadLinkElm = document.createElement("a")
				const csvFile         = new Blob(["\uFEFF"+csvStr], {type: "text/csv; charset=UTF-8"})

				// handle ie 11
				if( navigator.appVersion.toString().indexOf('.NET') > 0 ){
					window.navigator.msSaveOrOpenBlob( csvFile, filename ) 
				}
				// handle the good ones
				else{
					// File name
					downloadLinkElm.download = filename

					// Create a link to the file
					downloadLinkElm.href = window.URL.createObjectURL(csvFile);

					// Hide download link
					downloadLinkElm.style.display = "none";

					// Add the link to DOM
					document.body.appendChild(downloadLinkElm);

					// Click download link
					downloadLinkElm.click();
					
					// remove the created link after
					downloadLinkElm.remove();
				}
			},
			doDownloadPdf( layout = '', doLog = false ){ // handles the pdf downloads
				
				const filename    = this.outputData.filename
				const headerCells = this.outputData.headerCols
				const bodyRows    = []
				
				// generate bodyRows array for jsPdf 	
				this._.forEach( this.outputData.bodyRows, (row)=>{
					const newRow = this._.map( row.cells, (cell)=>{ return cell.value })
					bodyRows.push(newRow)
				});
				
				generateAndDownloadPDF(
					filename,
					this.selectedScheme,
					layout,
					headerCells,
					bodyRows,
				)
			},
			
			// diese funktion validiert das komplette doc erneut,
			// nützlich wenn eine neue row hingefügt oder entfernt wurde
			doValidateOutputData( doLog = true ){
				let outputData  = this.outputData
				let countErrors = 0
				let countCells  = 0
				
				if( doLog ){
					console.group('app • doValidateOutputData()')
					console.log('outputData:', outputData)
					console.groupEnd()
				}
				
				// walk the rows
				// walk the cells and validate each cell
				// trulify row.isValid if error in containing cell
				// set countErrors for doc
				outputData.bodyRows.forEach( (v, k)=>{
					const row   = v
					const cells = v.cells
					
					// walk the cells and validate each cell
					cells.forEach( (v, k)=>{
						const cell    = v
						const key     = cell.key
						const value   = cell.value
						const isValid = cell.ruleFn( value )
						
						cell.isValid = isValid
						
						// count all cells
						++countCells						
						// trulify row.isValid if error in containing cell
						if( !isValid ) row.isValid = false
						// increase countErrors
						if( !isValid ) ++countErrors
					})
				})
				
				outputData.countCells  = countCells
				outputData.countErrors = countErrors
			},
		},
		mounted() {
			//this.selectedScheme = 'Probenliste v3'
			//this.doParseCsv( this.currentHost + this.dev.testCsvFiles[0] )
			//this.showTableModal = true			
			//this.showHelpModal = true			
			//console.log('allSchemes:', allSchemes)
			
			// 2021-04-01  	Jose benötigte die Regeln des Validators 
			//				nochmal als Google Tables. Dafür habe ich 
			//				hier einen Output gebaut, denn man dann easy
			//				per Copy & Paste übertragen kann
			console.log('schemes:', this.schemes)
			
			this._.forEach( this.schemes, (v1, k1)=>{
				console.groupCollapsed(k1)
				const schemeRules = []
				
				this._.forEach( v1, (v2, k2)=>{
					const values = [
						k2, 
						v2.msgTitle, 
						v2.msgText, 
						v2.testFor,
					]
					const rulesRow = values.join("\t")
					schemeRules.push( rulesRow )
				})
				
				console.log( schemeRules.join("\n") );
				
				console.groupEnd()
			})
		}
	}
</script>

<style lang="less"> 
	@import (reference) "less/vars.less";
	@import "less/includes/normalize.include.less";
	@import "less/fonts.less";
	@import (reference) "less/mixins.less";
	@import "less/atoms.less";
	//@import "less/includes/grid.include.less";

	body {
		.font; 
		.font--sans; 
		.font--sizeDefault;
		
		max-width: 100vw;
		overflow-y: auto;
		overflow-x: hidden;
		
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	strong, b {
		.font--bold;
	}
	button {
		cursor: pointer;
	}
	h1, h2, h3, h4, h5 {
		font-size: inherit;
		line-height: inherit;
		font-weight: inherit;
		margin: 0;
	}
	a {
		cursor: pointer;
		color: @swatches[blue];
	}
	pre {
		@color: black;
		@fontSize: 14px;
		
		position: relative;
		padding: 0.5em;
		width: 100%;
		min-height: 2em;
		
		//margin-bottom: 0.5em;
		//margin-bottom: -1px;
		//&:first-of-type { margin-top: 1em; }
		//&:last-of-type { margin-bottom: 1em; }
		
		//color: fade(@color, 65);
		tab-size: 4;
		white-space: pre;
		font-size: @fontSize;
		line-height: 1.1em;
		
		outline: 1px solid fade(@color, 25);
		background-color: fade(@color, 5);
		overflow: auto;		
		//display: none;
		
		// label
		&[name]:after {
			position: absolute;
			top: 0; right: 0;
			background-color: fade(@color, 15);
			font-size: @fontSize*0.75;
			line-height: 1em;
			font-family: sans-serif;
			color: fade(@color, 75);
			padding: 0.25em 0.5em;
			content: attr(name);
			font-family: inherit;
		}		
		
		&:first-child {
			margin-top: 0em;
		}
	}
	hr {
		border: none;
		border-top: 1px solid;
		margin: 0.5em 0;
		opacity: 0.25;
	}
	ul, ol {
		margin-left: 1rem;
	}
	select {
		cursor: pointer;
		width: 100%;
	}
	label {
		cursor: pointer;
		user-select: none;
	}

	.layout {
		& {}
		
		&--app {
			display: grid;
			grid-template-columns: minmax(0, 300px) minmax(0, 1fr);
		}
	}
	.contentModule {
		[showBorders2] & {
			outline: 1px solid fade(red, 80);
			//.outline( red );
			.label( attr(class), fade(red, 80), black );			
		}
		
		[showBorders2] &__inner {
			outline: 1px dotted fade(red, 80);
		}
	}
	.contentModule {
		position: relative;
		
		&__inner {
			position: relative;
			margin: 0 auto;
		}
	}
	.view {
		//.hSpace--colGap;
		//padding: 1rem;
		display: flex;
		flex-direction: row;
		
		& > * > * {
			box-shadow: 0 0 1em 0em fade( black, 10 );
		}
	}
	.richText { // handle links usw.
		a {
			transition: all 0.1s ease;
			color: inherit;
			text-decoration: none;
			border-bottom: 1px solid fade( black, 25 );
		}
		a:hover {
			border-bottom-color: currentColor;
		}
	
		&.font--colorWhite a {
			border-bottom-color: fade( white, 25 );
		}
		&.font--colorWhite a:hover {
			border-bottom-color: white;
		}
	}
	.blend--multiply {
		//mix-blend-mode: multiply;
		//isolation: isolate;
		//transform: translateZ(1);
	}

	.BaseButton {
		width: 100%;
	}
	/*
	*/
	.BaseButton--downloadBtn {
		--activeBackgroundColor: @swatches[darkGreen];
		--hoverBackgroundColor: darken( @swatches[darkGreen], 5 );
	}
	.BaseFileInput {
		--activeBackgroundColor: @swatches[blue] !important;
		--hoverBackgroundColor: darken( @swatches[blue], 5 ) !important;
		width: 100%;
	}
	.BaseButton--validate {
		--activeBackgroundColor: @swatches[blue];
		--hoverBackgroundColor: darken( @swatches[blue], 5 );
		
		&.BaseButton--isDisabled {
			opacity: 0.5 !important;
			pointer-events: none;
		}
	}

	.MhModal {
		&__inner {
			max-height: 90vh;
			
			min-height: 50vh;
			overflow: hidden;
			
			border-radius: 0.25em;
			box-shadow: 0 0 1em 0em fade( black, 10 );		
		}
		
		&__header { border-bottom: 1px solid @swatches[grey]; }
		&__body { overflow: auto; flex-grow: 1; }
		&__footer { border-top: 1px solid @swatches[grey]; }
		
		&.modalWindow--help &__inner,
		&.modalWindow--imprint &__inner {
			min-height: 75vh;
			max-width: 750px;
		}
		&.modalWindow--datasets {}
		
		.modalWindow__closeBtn {
			padding-right: 0.25em;
		}
	}

	.app {}
	.app__bodyInner {}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
